/** Copyright (C) 2023 Trend Micro Inc. All rights reserved. */

import {
  FSS_LOCALSTORAGE_PREFIX,
  DEPLOY_ALL_IN_ONE_REGION_SELECTED,
  DEPLOY_SCANNER_REGION_SELECTED,
  DEPLOY_STORAGE_REGION_SELECTED,
  IS_ONE_PAGE_VIEWED,
  FSSStorageKeyType,
  LAST_TIME_DISPLAY_BAR_CHART_GUIDE,
  ACTIVE_PROVIDER,
  HAS_DISPLAYED_GCP_DM_DEPRECATED_ANNOUNCEMENT_MODAL,
} from '@constants/localStorageKey'

export const validKeyMap = [
  DEPLOY_ALL_IN_ONE_REGION_SELECTED,
  DEPLOY_SCANNER_REGION_SELECTED,
  DEPLOY_STORAGE_REGION_SELECTED,
  IS_ONE_PAGE_VIEWED,
  LAST_TIME_DISPLAY_BAR_CHART_GUIDE,
  ACTIVE_PROVIDER,
  HAS_DISPLAYED_GCP_DM_DEPRECATED_ANNOUNCEMENT_MODAL,
].reduce<Record<any, any>>((acc, cur) => {
  acc[cur] = true

  return acc
}, {})

export const keyValidator = (key: FSSStorageKeyType, cb: Function) => {
  const isValid = validKeyMap[key]

  if (isValid) {
    return cb()
  }
  console.error(new Error(`The key is not valid: ${key}`))
}

const clientStorage = {
  get: (key: FSSStorageKeyType) =>
    keyValidator(key, () =>
      window.localStorage.getItem(`${FSS_LOCALSTORAGE_PREFIX}${key}`)
    ),
  set: (key: FSSStorageKeyType, value: string) =>
    keyValidator(key, () =>
      window.localStorage.setItem(`${FSS_LOCALSTORAGE_PREFIX}${key}`, value)
    ),
}

export default clientStorage
